<template>
  <div ref="kksEditorContainer" class="kks-editor-container">
    <div :style="componentStyle" class="min-h-3rem">
      <!-- HACK: The PrimeVue Select component is used to force loading of -->
      <!-- needed PrimeVue styles. -->
      <PVSelect :style="{ display: 'none' }" />
      <!-- eslint-disable vue/no-mutating-props -->
      <kks-selector
        v-if="projectLocation"
        v-model="model[prop]"
        label=""
        :location="projectLocation.value"
        :show-filter-button="false"
        @change="handleTagsChanged"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { KksSelectorChangeEvent } from '@/components/TreeSelect/KksSelector.types';
  import { DEFAULT_METADATA_VALUES_SEPARATOR } from 'types';
  import { CSSProperties } from 'vue';
  import { nextTick } from 'vue';
  import { Ref } from 'vue';
  import { onMounted } from 'vue';
  import { ref } from 'vue';
  import { onBeforeUnmount } from 'vue';

  const componentStyle = ref<CSSProperties>({
    position: 'fixed',
    top: '0px',
    left: '0px',
  });

  const props = defineProps<{
    close: Function;
    model: Record<string, any>;
    prop: string;
    rowIndex: number;
    save: Function;
    projectLocation?: Ref<string>;
  }>();

  const currentInput = ref<string[]>([]);

  async function handleTagsChanged(
    event: KksSelectorChangeEvent,
  ): Promise<void> {
    currentInput.value = event.target.value.map((kks) => kks.kks_trimmed);
  }

  function saveInput(): void {
    props.save(currentInput.value.join(DEFAULT_METADATA_VALUES_SEPARATOR));
  }

  onBeforeUnmount(() => {
    saveInput();
  });

  const kksEditorContainer = ref<HTMLElement | null>(null);
  function positionKksSelector(): void {
    nextTick(() => {
      const element = kksEditorContainer.value as HTMLElement;
      const containingCell = (
        (element as HTMLElement)?.parentNode?.parentNode as HTMLElement
      )?.getBoundingClientRect();

      const rect = element.getBoundingClientRect();

      const topOffset = `${rect.top}px`;
      const leftOffset = `${rect.left}px`;
      const dateInputWidth = `${containingCell.width}px`;
      const dateInputHeigth = `${containingCell.height}px`;

      componentStyle.value.top = topOffset;
      componentStyle.value.left = leftOffset;
      componentStyle.value.width = dateInputWidth;
      componentStyle.value.minWidth = dateInputWidth;
      componentStyle.value.height = dateInputHeigth;
    });
  }

  onMounted(() => {
    positionKksSelector();
  });
</script>
